import { gql } from '@apollo/client';

export const GET_PAGE_VIEWS_BY_PAGE = gql`
  query GetPageViewsByPage($startDate: String!, $endDate: String!) {
    pageViewsByPage(startDate: $startDate, endDate: $endDate) {
      path
      views
      desktopViews
      mobileViews
    }
  }
`;

export const GET_PAGE_VIEWS_OVER_TIME = gql`
  query GetPageViewsOverTime($startDate: String!, $endDate: String!, $granularity: String) {
    pageViewsOverTime(startDate: $startDate, endDate: $endDate, granularity: $granularity) {
      date
      views
    }
  }
`;

export const GET_TOP_REFERRERS = gql`
  query GetTopReferrers($startDate: String!, $endDate: String!) {
    topReferrers(startDate: $startDate, endDate: $endDate) {
      domain
      views
    }
  }
`;

export const GET_PENDING_VIEW_COUNT = gql`
  query GetPendingViewCount {
    pendingViewCount
  }
`;
